import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const HMXSunsetGleam = () => (
  <ArticleWrapper articleId="hmx_sunset_gleam">
    <div className="prose prose-invert mx-auto p-6">
      <h1>HMX Sunset Gleam</h1>
      {/* Add your HMX Sunset Gleam article content here */}
      <p>This is a placeholder article for the HMX Sunset Gleam switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default HMXSunsetGleam;
